import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Fetch } from "../../../shared/Fetch";

interface Iprops {
    req_id: number,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const RejectReq = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [reason, setReason] = useState("");

    const rejectReq = async () => {
        if (reason.length > 0) {
            setLoading(true);
            const response = await Fetch("Requirement_MAST/reject", "PUT", null, `req_id=${props.req_id}&reason=${reason}`, props.toast);
            if (response) {
                props.setReload(!props.reload);
                const message = await response.text();
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                onHide();
            }
            setLoading(false);
        } else props.toast.current.show({ severity: 'error', detail: "Provide the requirement rejection reason.", life: 3000 });
    }

    const onHide = () => {
        props.hideDialog();
        setReason("");
    }

    const dFooter = () => {
        return (<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
            <Button loading={loading} className="p-button-sm my-1" label="REJECT" onClick={rejectReq} type="button"></Button>
            <Button className="p-button-sm p-button-outlined my-1" label="CLOSE" onClick={onHide} type="button"></Button>
        </div>);
    }

    return (
        <Dialog visible={props.open} style={{ width: '60vw' }} header={`Reject Requirement ${props.req_id} ?`} footer={dFooter} className="p-fluid" draggable={false} onHide={onHide}>
            <div className="p-fluid formgrid grid">
                <div className="col-12 md:col-12 md:col-6">
                    <label htmlFor="reason">Rejection Reason <span style={{ color: 'red' }}>*</span></label>
                    <CKEditor editor={ClassicEditor} data={reason} onChange={(event, editor) => { setReason(editor.getData()); }} />
                </div>
            </div>
        </Dialog>
    );
}